/* Libraries / React Components / Node_Modules */
import React, { useEffect, useState, useRef, memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import $ from "jquery";
// NO axios import or @mui imports

import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

/* Local Imports */
import Pagination from "../Pagination/Pagination";
// NO API_URL import
import Loader from "../resuableComponent/loader";
import BasicLineColumn from "../common/apexChart/lineChart";

/* Data */
import {
  getDnsDetails,
  fetchSubDomains,
  addRemediationData,
  removeRemediationData,
} from "../../actions/sub-domain";

import RemediationActionButton from "../common/RemediationActionButton";
import { useRemediationActions } from "../../hooks/useRemediationActions";

// DNS Health Page
const DNSHealth = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const myRef = useRef(null);

  // no auth?
  const clientType = useSelector((state) => state?.auth?.user?.accessLevel);
  const id = useSelector(
    (state) =>
      state?.summary?.localClient?._id ||
      state?.summary?.clients?.data?.[0]?._id
  );
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.data?.[0]
  );
  const dnsDetailsArray = useSelector(
    (state) => state.subDomain?.dnsDetails?.data
  );
  const oldDnsDetails = useSelector(
    (state) => state.subDomain?.dnsDetails?.scanDetailArray
  );
  const scanCompleted = useSelector((state) => state.subDomain?.scanCompleted);
  const remediationList = useSelector(
    (state) => state?.auth?.remediationListAll?.data?.data
  );

  // =============== State Management ===============
  // PAGINATION_AND_DISPLAY
  const [page, setPage] = useState(1);
  const [PageSize, setPerPage] = useState(10);
  const [containerClass, setContainerClass] = useState("data-container");

  // FILTERING_AND_SEARCH
  const [search, setSearch] = useState("");
  const [filterData, setfilterData] = useState("all");
  const [domainFilter, setDomainFilter] = useState("all");

  // IDENTIFIERS_AND_METADATA
  const [checkPath, setCheckPath] = useState("");

  // ACTION_MANAGEMENT
  const [addedRemediations, setAddedRemediations] = useState([]);

  // ====== COMPUTED VALUES & CONSTANTS ======
  const queryParameters = new URLSearchParams(window.location.search);
  const latest = queryParameters.get("latest");

  // Handle latest filter parameter
  useEffect(() => {
    if (latest && filterData === "all") {
      setfilterData("Latest");
    }
  }, [latest, filterData]);

  // Domain processing
  let domain = [];
  if (client?.website) {
    let processedDomain = client.website.replace(
      /^(?:https?:\/\/)?(?:www\.)?/i,
      ""
    );
    if (processedDomain?.charAt(processedDomain.length - 1) === "/") {
      domain = [processedDomain.substr(0, processedDomain.length - 1)];
    } else {
      domain = [processedDomain];
    }
  }
  if (client?.domains && client.domains.length > 0) {
    domain = client.domains;
  }

  // Filter processing with error handling
  let distinctFilter = ["all", "Latest"];
  try {
    const filterValue = dnsDetailsArray?.map((row) => row?.recordType);
    const uniqueFilters = filterValue?.filter(
      (item, index, self) => self.indexOf(item) === index
    );
    if (uniqueFilters && uniqueFilters.length > 0) {
      distinctFilter = ["all", ...uniqueFilters, "Latest"];
    }
  } catch (error) {
    console.error("Error processing filters:", error);
  }

  // Filter issues and warnings
  const issuesFound = dnsDetailsArray?.filter(
    (row) =>
      row?.recordType === "spf" &&
      !row?.valid &&
      row?.record?.indexOf("SPF TXT record") === -1 &&
      row?.record?.indexOf("does not exist") === -1
  );
  const warningFound = dnsDetailsArray?.filter(
    (row) =>
      (row?.recordType === "dmarc" && !row?.valid) ||
      (row?.recordType === "MX" && row?.hosts?.length > 0 && !row?.valid)
  );

  // Arrays for charts
  let openPortArray = [];
  let ipArray = [];
  for (let count = 0; count < oldDnsDetails?.scanDetails?.length; count++) {
    const compliantDataOld = oldDnsDetails?.scanDetails?.[count]?.filter(
      (row) => row?.valid
    );
    let compliantDataOldPercentage =
      (compliantDataOld?.length / oldDnsDetails?.scanDetails?.[count]?.length) *
      100;
    ipArray.push(oldDnsDetails?.scanDetails?.[count]?.length || 0);
    openPortArray.push(compliantDataOldPercentage?.toFixed(0));
  }

  // Process new domains
  let newAddedDomain = [];
  if (client?.scanCounter > 0) {
    let oldScanData = oldDnsDetails?.scanDetails[client?.scanCounter - 1];
    for (let vuln = 0; vuln < dnsDetailsArray?.length; vuln++) {
      let flag = true;
      for (let oldVuln = 0; oldVuln < oldScanData?.length; oldVuln++) {
        if (
          dnsDetailsArray[vuln].subDomain == oldScanData[oldVuln].subDomain &&
          dnsDetailsArray[vuln].recordType == oldScanData[oldVuln].recordType
        ) {
          flag = false;
          break;
        }
      }
      if (flag) {
        newAddedDomain.push(dnsDetailsArray[vuln]);
      }
    }
    //console.log(newAddedDomain,'scanDetails');
  }

  // Data filtering - create filtered array based on domain filter
  let filteredDnsData = dnsDetailsArray;
  if (domainFilter !== "all") {
    filteredDnsData = dnsDetailsArray?.filter(
      (val) => val?.subDomain.indexOf(domainFilter) !== -1
    );
  }

  // Define recordAddedInLast30Days before using it
  const recordAddedInLast30Days = filteredDnsData?.filter(
    (row) =>
      moment(row?.createdAt).isBefore(moment()) &&
      moment(row?.createdAt).isAfter(moment().subtract(90, "days"))
  );

  let mapData =
    filterData === "all"
      ? filteredDnsData
      : filterData === "Issues"
      ? issuesFound
      : filterData === "Warnings"
      ? warningFound
      : filterData === "Last 30 days"
      ? recordAddedInLast30Days
      : filterData === "Latest"
      ? newAddedDomain
      : filteredDnsData?.filter((row) => row?.recordType === filterData);

  mapData = mapData?.filter((res) => {
    if (search === "") {
      return res;
    } else if (
      res?.recordType?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1 ||
      res?.subDomain?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1
    ) {
      // (res?.records?.map((row) => row.indexOf(search) != -1)) )
      return res;
    }
    return false; // Return false for items that don't match the search
  });

  let currentTableData = [];
  try {
    if (mapData && Array.isArray(mapData) && mapData.length > 0) {
      const firstPageIndex = (page - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      currentTableData = mapData.slice(firstPageIndex, lastPageIndex);
    }
  } catch (error) {
    console.error("Error processing table data:", error);
    currentTableData = [];
  }

  const remediationActions = useRemediationActions(
    "dnsdetails",
    id,
    currentTableData
  );

  // =============== Effect Hooks ===============
  // Update path when location changes
  useEffect(() => {
    setCheckPath(location.search);
  }, [location.search]);

  // Fetch data
  useEffect(() => {
    getDnsDetails(id, dispatch);
  }, [id, dispatch]);

  // Update remediation list when it changes
  useEffect(() => {
    if (remediationList) {
      setAddedRemediations(
        remediationList.reduce(
          (results, elem) => Object.assign(results, { [elem._id]: elem }),
          {}
        )
      );
    }
  }, [remediationList]);

  // Update container class when state is loaded
  useEffect(() => {
    if (dnsDetailsArray) {
      setTimeout(() => {
        setContainerClass("data-container active");
      }, 300);
    }
  }, [dnsDetailsArray]);

  // ========= Handlers / Functions =========
  // Scroll handler
  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  // ====== Export/Download Functions ======
  // Export to CSV
  const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };
  // Download CSV
  const downloadCsvData = dnsDetailsArray?.map((res) => ({
    DomainName: res?.subDomain,
    RecordType: res?.recordType,
    Record: JSON.stringify(
      res?.recordType == "MX"
        ? res.valid
          ? res?.hosts?.map((row) => row[0]?.hostname)
          : res?.warnings?.map((row) => row?.hostname)
        : res?.record
    )
      ?.replace(/[[\]']+/g, "")
      ?.replace(/['"]+/g, ""),
    LastUpdated: moment(res?.createdAt).format("DD-MM-YYYY"),
  }));
  // ====== END Export/Download Functions ======

  // ======= Remediation List Bucket =======
  // Remove item from remediation bucket
  const removeToCart = (_id) => (e) => {
    $.confirm({
      title: "Are you sure?",
      content:
        "Do you really want to remove this from the Remediation List Panel?",
      type: "red",
      buttons: {
        ok: {
          text: "Remove",
          btnClass: "btn-danger",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            removeRemediationData(_id, dispatch, id).then((res) => {
              fetchSubDomains(id, page, dispatch, "all");
            });
          },
        },
        cancel: function () {},
      },
    });
  };
  // Adds item to remediation bucket
  const addToCart = (row) => (e) => {
    let data = {
      collectionName: "dnsdetails",
      organisationId: id,
      recordId: row?._id,
      moduleName: "dnns_details",
    };
    $.confirm({
      title: "Are you sure?",
      content: "Do you really want to add this to the Remediation List Panel ?",
      type: "green",
      buttons: {
        ok: {
          text: "Add",
          btnClass: "btn-green",
          keys: ["enter"],
          action: function () {
            e.preventDefault();
            addRemediationData(data, dispatch).then((res) => {
              fetchSubDomains(id, page, dispatch, "all");
            });
          },
        },
        cancel: function () {},
      },
    });
  };
  // ===== END Remediation List Bucket =====

  // Debug logging (comment out for production)
  // console.log('SubDomain Debug:', {
  //   id,
  //   client,
  //   dnsDetailsArray: dnsDetailsArray ? dnsDetailsArray.length : 'null',
  //   containerClass,
  //   currentTableData: currentTableData ? currentTableData.length : 'null'
  // });

  // Early return if no client ID
  if (!id) {
    return <div>Loading client information...</div>;
  }

  return (
    <div>
      {/* <Header type="security" />
      <SideNav type="security" /> */}

      {dnsDetailsArray &&
      Array.isArray(dnsDetailsArray) &&
      dnsDetailsArray.length > 0 ? (
        <div className={containerClass}>
          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9">
              <div className="row_boxes">
                <div className="gradinet-effect w-100">
                  {oldDnsDetails && (
                    <BasicLineColumn
                      dates={oldDnsDetails?.dates}
                      // openPortArray={openPortArray}
                      ipArray={ipArray}
                      color={["#ffd861", "#E15858"]}
                      yAxis={"IP Assets"}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix no_margin" style={{ marginTop: "20px" }}>
            <div className="col-sm-2"></div>
            <div className="col-sm-9" style={{ padding: "0" }}>
              <div className="row_boxes row_boxes_table">
                <div className="table_box">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Domain Name</th>
                        <th>Record Type</th>
                        <th>Record</th>
                        <th>Observation</th>
                        <th>Last Modified On</th>
                        {/**/}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentTableData?.map((row, index) => {
                        const pageCount = (page - 1) * 10 + 1;
                        return (
                          <tr key={row?._id || `row-${index}`}>
                            {/*#*/}
                            <td>
                              {pageCount + index}
                              {row?.isProcessed}
                            </td>
                            {/*Domain Name*/}
                            <td style={{ whiteSpace: "unset" }}>
                              <a
                                href={`https://${row?.subDomain}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {`${row?.subDomain}`}
                              </a>
                            </td>
                            {/*Record Type*/}
                            <td>{row?.recordType}</td>
                            {/*Record*/}
                            <td style={{ whiteSpace: "unset" }}>
                              {row?.recordType === "MX"
                                ? row.valid
                                  ? row?.hosts?.map((req, reqIndex) => {
                                      return (
                                        <React.Fragment key={reqIndex}>
                                          <span>{req[0]?.hostname}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    })
                                  : row?.warnings?.map((req, reqIndex) => {
                                      return (
                                        <React.Fragment key={reqIndex}>
                                          <span>{req?.hostname}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    })
                                : row?.record}
                            </td>
                            {/*Observation*/}
                            <td></td>
                            {/*<td style={{ whiteSpace: "unset" }}>
                              {row?.recordType == "spf" && !row?.valid && row?.record?.indexOf("SPF TXT record") == -1 && row?.record?.indexOf("does not exist") == -1 ? (
                                <span className="badge badge-danger">
                                  {row?.record}
                                </span>
                              ) : row?.recordType == "dmarc" && !row?.valid ? (
                                <span className="badge badge-danger">
                                  {row?.record}
                                </span>
                              ) : row?.recordType == "MX" && row?.hosts?.length > 0 && !row?.valid ? (
                                <span className="badge badge-danger">
                                  {row?.record}
                                </span>
                              ) : row?.recordType == "MX" && row?.hosts?.length > 0 && row?.valid ? (
                                <span className="badge badge-success">
                                  {row?.record}
                                </span>
                              ) : row?.recordType == "MX" && row?.hosts?.length == 0 && !row?.valid ? (
                                <span className="badge badge-danger">
                                  {row?.record}
                                </span>
                              ) : row?.recordType == "MX" && row?.hosts?.length == 0 && row?.valid ? (
                                <span className="badge badge-success">
                                  {row?.record}
                                </span>
                              ) : row?.valid ? (
                                <span className="badge badge-success">
                                  {row?.record}
                                </span>
                              ) : (
                                <span className="badge badge-danger">
                                  {row?.record}
                                </span>
                              )}
                            </td>*/}
                            {/*Last modified on*/}
                            <td style={{ whiteSpace: "unset" }}>
                              <span className="badge badge-success">
                                {moment(
                                  row?.updatedAt || row?.createdAt
                                ).format("DD-MM-YYYY")}
                              </span>
                            </td>
                            <td>
                              {clientType === "Admin" && (
                                <RemediationActionButton
                                  row={row}
                                  shouldShowPlus={remediationActions.shouldShowPlusButton(
                                    row
                                  )}
                                  onAdd={() =>
                                    remediationActions.addToCart(
                                      row,
                                      "dns_records"
                                    )
                                  }
                                  onRemove={remediationActions.removeFromCart}
                                  clientType={clientType}
                                  remediationType="DNS Health"
                                />
                              )}
                            </td>
                            {/* {checkPath === "?mode=assessment-mode" &&
                            clientType === "Admin" ? (
                              <td>
                                
                                {row?.isTicketChecked === false ? (
                                  <button
                                    onClick={addToCart({
                                      ...row,
                                      remediationType: "Sub Domain",
                                    })}
                                  >
                                    <span className="fa fa-plus action_icon"></span>
                                  </button>
                                ) : (
                                  <button onClick={removeToCart(row?._id)}>
                                    <span className="fa fa-minus action_icon"></span>
                                  </button>
                                )}
                              </td>
                            ) : null}
                            {clientType === "Admin" ? (
                              <td>
                                {row?.isTicketChecked === false ? (
                                  <button
                                    onClick={addToCart({
                                      ...row,
                                    })}
                                  >
                                    <span className="fa fa-plus action_icon"></span>
                                  </button>
                                ) : (
                                  <button onClick={removeToCart(row?._id)}>
                                    <span className="fa fa-minus action_icon"></span>
                                  </button>
                                )}
                              </td>
                            ) : null} */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="dataTables_paginate">
                {mapData && mapData.length > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={mapData?.length}
                    pageSize={PageSize}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
                {/*
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={PageSize}
                    onPageChange={(page) => setPage(page)}
                  />
                )} 
              */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ padding: "50px", textAlign: "center" }}>
          {dnsDetailsArray === null ? (
            <Loader />
          ) : (
            <div>
              <h3>No DNS data available</h3>
              <p>Click the scan button to start a DNS analysis.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(DNSHealth);
